import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import { takeWhile } from 'rxjs/operators';
import { ShippingCharge } from '../models';

@Component({
  selector: 'opus-shipping-charges-table-row',
  templateUrl: './shipping-charges-table-row.component.html'
})
export class ShippingChargesTableRowComponent implements OnInit, OnDestroy, OnChanges {
  @Input() isEditing: boolean;
  @Input() updatingShippingCharges: boolean;
  @Input() isOdd: boolean;
  @Input() isLast: boolean;
  @Input() chargeItm: ShippingCharge;
  @Input() item: FormGroup;

  //alive = true;

  ngOnInit() {}

  ngOnDestroy() {
    /*  this.alive = false;*/
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isEditing !== undefined) {
      if (changes.isEditing.currentValue === false) {
        //	when the editor is closed, sych up with the actual shipping charge model
        if (!this.updatingShippingCharges) {
          this.resetForm();
        }

        this.item.disable();
      } else if (changes.isEditing !== undefined && changes.isEditing.currentValue === true) {
        if (this.updatingShippingCharges) {
          this.updatingShippingCharges = false;
          this.isEditing = false;
        }
        this.item.enable();
      }
    }
  }

  resetForm() {
    this.item.reset({
      rentalCategoryName: this.chargeItm.rentalCategoryName,
      rentalCategoryCode: this.chargeItm.rentalCategoryCode,
      state: this.chargeItm.state,
      ground: this.chargeItm.ground,
      twoDay: this.chargeItm.twoDay,
      overnight: this.chargeItm.overnight
    });
  }

  static BuildItem(charge: ShippingCharge): FormGroup {
    return new FormGroup({
      rentalCategoryName: new FormControl(charge.rentalCategoryName),
      rentalCategoryCode: new FormControl(charge.rentalCategoryCode),
      state: new FormControl(charge.state),
      ground: new FormControl(charge.ground),
      twoDay: new FormControl(charge.twoDay),
      overnight: new FormControl(charge.overnight)
    });
  }
}
